import React from 'react';
import { Field } from '../../pages/AdminStoreDetail/Menu/ProductItem/ProductOrderSheet/ProductEditModal/styled';
import { HeaderSmall } from '../Text';
import Draggable from '../Draggable';
import { changeOrderHelper } from '@/utils/data';
import i18n from '@/utils/i18n';

type ValuesType = {
  extra_groups: Array<{
    extra_group_id: string;
    name: string;
    items: string | any[];
  }>;
};

type ExtraGroupFormSectionProps = {
  values: ValuesType;
  setValues: (props: ValuesType) => void;
};

export default function ExtraGroupFormSection({
  values,
  setValues,
}: ExtraGroupFormSectionProps) {
  function sortExtraGroups(extraGroupId: string, targetExtraGroupId: string) {
    setValues({
      ...values,
      extra_groups: changeOrderHelper(
        values.extra_groups,
        'extra_group_id',
        extraGroupId,
        targetExtraGroupId,
      ),
    });
  }

  function onDragStartExtraGroup(event: any) {
    event.dataTransfer.setData('text/plain', event.target.id);
  }

  function onDragOverExtraGroup(event: any) {
    event.preventDefault();
  }

  function onDropExtraGroup(event: any) {
    const extraIdToMove = event.dataTransfer.getData('text');
    sortExtraGroups(extraIdToMove, event.target.id);
    event.dataTransfer.clearData();
  }

  return (
    <Field>
      <HeaderSmall>{i18n.t('Menu:changeExtraGroupOrder')}</HeaderSmall>
      {(values.extra_groups || []).map((extraGroup) => (
        <Draggable
          key={extraGroup.extra_group_id}
          id={extraGroup.extra_group_id}
          onDragStart={onDragStartExtraGroup}
          onDragOver={onDragOverExtraGroup}
          onDrop={onDropExtraGroup}
          draggable
        >
          {extraGroup.name}
          {` (${extraGroup.items.length} extras)`}
        </Draggable>
      ))}
    </Field>
  );
}
